// Route map (WEB_PLAN.md §5.0). Each screen lives in features/<area>/ and is owned by one work package; this file
// only wires them up.
import { createBrowserRouter, Navigate, Outlet } from 'react-router';
import { RequireCompany, RequireNoCompany, RequireSignedOut } from '@/auth/AuthGate';
import AccountPage from '@/features/account/AccountPage';
import AppleCallbackPage from '@/features/auth/AppleCallbackPage';
import ForgotPasswordPage from '@/features/auth/ForgotPasswordPage';
import SignInPage from '@/features/auth/SignInPage';
import SignUpPage from '@/features/auth/SignUpPage';
import VerifyCodePage from '@/features/auth/VerifyCodePage';
import DashboardPage from '@/features/dashboard/DashboardPage';
import DocumentsPage from '@/features/documents/DocumentsPage';
import FollowUpsPage from '@/features/followups/FollowUpsPage';
import MapPage from '@/features/map/MapPage';
import PipelinePage from '@/features/pipeline/PipelinePage';
import ComingSoonPage from '@/features/placeholder/ComingSoonPage';
import AppShell from '@/features/shell/AppShell';
import StoreDetailPage from '@/features/stores/StoreDetailPage';
import StoresPage from '@/features/stores/StoresPage';
import RepDetailPage from '@/features/team/RepDetailPage';
import TeamPage from '@/features/team/TeamPage';
import TerritoriesPage from '@/features/territories/TerritoriesPage';
import TerritoryDetailPage from '@/features/territories/TerritoryDetailPage';
import WelcomePage from '@/features/welcome/WelcomePage';
import { SyncProvider } from '@/sync/SyncProvider';

export const router = createBrowserRouter([
  {
    element: (
      <RequireSignedOut>
        <Outlet />
      </RequireSignedOut>
    ),
    children: [
      { path: '/sign-in', element: <SignInPage /> },
      { path: '/sign-up', element: <SignUpPage /> },
      { path: '/verify', element: <VerifyCodePage /> },
      { path: '/forgot', element: <ForgotPasswordPage /> },
    ],
  },
  { path: '/auth/apple', element: <AppleCallbackPage /> },
  {
    path: '/welcome',
    element: (
      <RequireNoCompany>
        <WelcomePage />
      </RequireNoCompany>
    ),
  },
  {
    element: (
      <RequireCompany>
        <SyncProvider>
          <AppShell />
        </SyncProvider>
      </RequireCompany>
    ),
    children: [
      { path: '/', element: <DashboardPage /> },
      { path: '/team', element: <TeamPage /> },
      { path: '/team/:profileId', element: <RepDetailPage /> },
      { path: '/stores', element: <StoresPage /> },
      { path: '/stores/:id', element: <StoreDetailPage /> },
      { path: '/follow-ups', element: <FollowUpsPage /> },
      { path: '/map', element: <MapPage /> },
      { path: '/territories', element: <TerritoriesPage /> },
      { path: '/territories/:id', element: <TerritoryDetailPage /> },
      { path: '/pipeline', element: <PipelinePage /> },
      { path: '/documents', element: <DocumentsPage /> },
      { path: '/reports', element: <ComingSoonPage title="Reports" phase={3} /> },
      { path: '/leaderboard', element: <ComingSoonPage title="Leaderboard" phase={3} /> },
      { path: '/settings/*', element: <ComingSoonPage title="Settings" phase={2} /> },
      { path: '/account', element: <AccountPage /> },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
]);
